import React , { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import Tickets from '../components/Tickets';
import { FaSearch } from 'react-icons/fa';

const SearchWrapper = styled.div`
  width: 100%;
`;

const Title = styled.div`
  width: 100%;
  background: white;
  border-top: solid 1px #EFF2F4;
  border-bottom: solid 1px #EFF2F4;
  padding: 30px 0;
  text-align: center;
  font-size: 20px;
`;

const SearchPart = styled.div`
  width: 100%;
  position: relative;
  background: #EFF2F4;
`;

const SearchIcon = styled(FaSearch)`
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #bbb;
`;

const SearchInput = styled.input`
  width: -webkit-fill-available;
  margin: 20px;
  border: 1px solid #C4C4C4;
  border-radius: 36px;
  padding: 10px 40px;
  outline: none;
  font-size: 13px;

  &::placeholder {
    color: #818181;
  }
`;

function SearchPage() {
  const { location } = useParams();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(useLocation().search);
  const keyword = urlParams.get("keyword")?.toLowerCase() || "";
  const [searchText, setSearchText] = useState('');

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      navigate(`/location/${location}/search?keyword=${encodeURIComponent(searchText.trim())}`);
    }
  };

  return (
    <>
      <Helmet>
        <title>{keyword} - MusePicker</title>
        <meta name="description" content="Explore events and tickets by category" />
        <meta name="keywords" content="category, tickets, events" />
        <meta name="author" content="MusePicker" />
      </Helmet>

      <SearchWrapper>
        <Title>Search Results for "{keyword}"</Title>
        <SearchPart>
          <SearchIcon />
          <SearchInput
            type="text"
            placeholder={`Search for things to do in ${location}`}
            value={searchText}
            onChange={handleSearchChange}
            onKeyDown={handleSearchKeyDown}
          />
          </SearchPart>
        <Tickets location={location} searchKeyword={keyword} />
      </SearchWrapper>
    </>
  );
}

export default SearchPage;
